const ACCESS_TOKEN_EXPIRY_SKEW_SECONDS = 30;

/** Returns true only for a JWT access token that will remain valid long enough to send. */
export const isAccessTokenUsable = (token: string | null): token is string => {
    if (!token) return false;

    try {
        const payloadPart = token.split(".")[1];
        if (!payloadPart) return false;

        const normalized = payloadPart.replace(/-/g, "+").replace(/_/g, "/");
        const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");
        const payload = JSON.parse(atob(padded)) as { exp?: unknown; token_type?: unknown };
        const expiresAt = Number(payload.exp);

        return (
            Number.isFinite(expiresAt) &&
            expiresAt > Math.floor(Date.now() / 1000) + ACCESS_TOKEN_EXPIRY_SKEW_SECONDS &&
            (!payload.token_type || payload.token_type === "access")
        );
    } catch {
        return false;
    }
};
